import { differenceInCalendarDays, parseISO } from 'date-fns';
import { EnrichedNotification } from '../types/notification';

// Builds the French label for a notification from its type + referenced entity.
// Keeping the wording here (rather than in the DB) lets it evolve freely.
export function buildNotificationMessage(notification: EnrichedNotification): string {
  const title = notification.reminder?.title ?? 'Rappel';

  switch (notification.type) {
    case 'reminder_due_soon': {
      if (!notification.reminder) {
        return `Le rappel « ${title} » arrive à échéance.`;
      }

      const days = Math.max(
        0,
        differenceInCalendarDays(parseISO(notification.reminder.due_date), new Date())
      );

      if (days === 0) {
        return `Le rappel « ${title} » arrive à échéance aujourd'hui.`;
      }

      if (days === 1) {
        return `Le rappel « ${title} » arrive à échéance demain.`;
      }

      return `Le rappel « ${title} » arrive à échéance dans ${days} jours.`;
    }

    case 'reminder_due':
      return `Le rappel « ${title} » est arrivé à échéance.`;

    case 'event_created':
      return `Un nouvel événement a été ajouté : ${notification.event?.title ?? 'Événement'}.`;

    default:
      return `Le rappel « ${title} ».`;
  }
}
